import { Component, HostBinding, Injector, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonHeaderComponent } from '../common-header.component';
import { UpaService, UpaTarget } from '../../../services/upa.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'heading-video',
  template: `
    <div class="header-wrapper" id="{{htmlId}}" [style.backgroundColor]="hasBackgroundPicture ? '' : backgroundColor">

        <youtube-embeded [module]="youtubeVideoModule" class="heading"></youtube-embeded>

        <eva-subnav *ngIf="subnavModule" [viewType]="subnavViewType" [subnav]="subnavModule" [product]="'nymeria-gui'" [flow]="flow" (onClickSubnavItem)="trackUpa($event)"></eva-subnav>
    </div>
    `,
  styleUrls: ['./heading-video.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class HeadingVideoComponent extends CommonHeaderComponent implements OnInit {

  hasBackgroundPicture: boolean = false;
  youtubeVideoModule: any;

  constructor(injector: Injector, private upaService: UpaService, private sanitizer: DomSanitizer) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();
    this.hasBackgroundPicture = this.module.data.background.picture && this.module.data.background.picture != '' ? true : false;
    this.youtubeVideoModule = {
      data: {
        youtube_video_key: this.module.data.youtube_video_id,
        youtube_video_loop: this.module.data.youtube_video_loop ?? false,
        youtube_video_auto_play: this.module.data.youtube_video_auto_play ?? false,
        background: this.module.data.background?.picture
      }
    };
  }

  trackUpa($event) {
    this.module.data.subnav.items.forEach((item, index) => {
      if (item.target.value == $event.value) {
        this.upaService.trackClickTopic({
          label: item.title,
          positionIndex: index,
          moduleId: this.module.id,
          moduleIndex: this.module.position,
          target: UpaTarget.HEADING,
          uniqueId: this.module.unique_id
        })
      }
    });
  }

}
